/**
 * Idle-prefetch данных панелей (C3): после загрузки страницы, на простое браузера,
 * тихо прогреваем SWR-кеш — первое открытие панели тоже мгновенное.
 */
(function () {
  'use strict';

  function idle(fn) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: 5000 });
    } else {
      setTimeout(fn, 2500);
    }
  }

  function isAuthed() {
    try {
      if (localStorage.getItem('goszemlya_web_token')) return true;
    } catch (e) {}
    if (window.Telegram && Telegram.WebApp && Telegram.WebApp.initData) return true;
    return false;
  }

  idle(function () {
    if (typeof window.swrWarm !== 'function') return;
    // Статистика нужна всем (панель «Инфо»)
    window.swrWarm('stats', '/api/stats');
    // Объявления — только авторизованным (иначе бессмысленный 401)
    if (isAuthed()) window.swrWarm('myads', '/api/user/ads');
  });
})();
